import React, {Component} from 'react';
import {Button, Modal} from 'semantic-ui-react';

import {connect} from "react-redux";
import {openPrinterSettingsModal} from "../../actions/PrinterSettingsModalAction";
import PrinterForm from "./PrinterForm";

class PrinterSettingsModal extends Component {

    handleClose = () => {
        this.props.openPrinterSettingsModal({is_open:false});
    };

    render() {
        return (
            <Modal size='small' dimmer='inverted' open={this.props.modal.is_open} onClose={this.handleClose}>
                <Modal.Header>Configurar Impresora</Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        <PrinterForm />
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cerrar"/>
                </Modal.Actions>
            </Modal>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        openPrinterSettingsModal(modal) {
            dispatch(openPrinterSettingsModal(modal));
        }
    }
}

function mapStateToProps(state){
    return{
        modal: state.get('printer_settings_modal')
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PrinterSettingsModal)




// WEBPACK FOOTER //
// ./src/components/printer/PrinterSettingsModal.js